import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { marginLeft } from 'utils';

export const StyledMeuContainer = styled('div')(
  ({ theme, isDeletingAllHistory }) => css`
    .history-container {
      width: 'fit-content';
      padding: 12px 16px;
      display: flex;
      flex-direction: column;

      .history-header {
        text-align: ${isDeletingAllHistory ? 'center' : 'right'};
        margin: ${isDeletingAllHistory ? '24px' : '0'};
        width: 100%;
        color: ${isDeletingAllHistory
          ? '#0c395a'
          : theme.palette.secondary.lighter};
        font-size: ${theme.typography.caption.fontSize};
        font-weight: ${theme.typography.caption.fontWeight};
        line-height: ${theme.typography.caption.lineHeight};
      }

      .divider {
        width: 100%;
        background-color: ${theme.palette.secondary.lightest};
        height: 2px;
      }
      .history-items-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding: 8px 0px;
        .history-item {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: column;
          border-radius: 8px;
          padding: 0px 6px;
          cursor: pointer;
          overflow: hidden;

          &.skeleton {
            cursor: default;
            pointer-events: none;
            gap: 6px;

            &:hover {
              background-color: transparent;
            }

            .MuiSkeleton-root {
              border-radius: 4px;
            }
          }

          &:hover {
            background-color: ${theme.palette.secondary.lightest};
          }

          .date {
            white-space: nowrap;
            direction: ltr;
            ${marginLeft('auto')}
            color: ${theme.palette.secondary.light};
            font-size: ${theme.typography.captionLight.fontSize};
            font-weight: ${theme.typography.captionLight.fontWeight};
            line-height: ${theme.typography.captionLight.lineHeight};
          }

          .content {
            flex-grow: 1;
            min-width: 0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: ${theme.palette.secondary.light};
            font-size: ${theme.typography.caption.fontSize};
            font-weight: ${theme.typography.caption.fontWeight};
            ${theme.breakpoints.down('sm')} {
              min-height: 20px;
            }
          }

          .clear-icon {
            ${theme.breakpoints.down('md')} {
              position: absolute;
              top: 4px;
              left: 4px;
            }
          }

          ${theme.breakpoints.up('md')} {
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: 12px;

            &.skeleton {
              justify-content: flex-start;
            }

            .clear-icon {
              visibility: hidden;
            }

            &:hover {
              background-color: ${theme.palette.secondary.lightest};
              .clear-icon {
                visibility: visible;
              }
            }
          }
        }
      }
      .delete-progress {
        width: 100%;
        height: 2px;
        overflow: hidden;
        background-color: transparent;
      }

      .delete-progress span {
        display: block;
        width: 100%;
        height: 100%;
        background-color: #12aeb5;
        transform-origin: left center;
        transform: scaleX(0);
      }

      .delete-progress--active span {
        animation: delete-history-progress 3s linear forwards;
      }

      @keyframes delete-history-progress {
        from {
          transform: scaleX(1);
        }

        to {
          transform: scaleX(0);
        }
      }
    }
  `
);
